import { Stack } from '@mui/material';
import classNames from 'classnames';
import React, { memo } from 'react';
import useStyles from '../styles';

const CompanyQueryColumn: React.FC = () => {
  const classes = useStyles();

  return (
    <Stack
      direction="row"
      className={classNames(classes.header)}
      spacing={1}
      alignItems="center"
      justifyContent="flex-start"
      width="100%"
    >
      <span>{'Primary Entity'}</span>
    </Stack>
  );
};

export default memo(CompanyQueryColumn);
